module.exports = __webpack_public_path__ + "img/order_calendar_1.caf0be67.png";